import { Action } from '@ngrx/store';
import {DeviceGroupParam, Group} from '../../models/group';

export enum GroupDetailActionTypes {
  GetGroupDetails = '[GroupDetail] Get GroupDetails',
  LoadGroupDetails = '[GroupDetail] Load GroupDetails',
  UpdateGroupDetails = '[GroupDetail] Update GroupDetails'
}

export class GetGroupDetails implements Action {
  readonly type = GroupDetailActionTypes.GetGroupDetails;
  constructor(public payload: number) {}
}
export class LoadGroupDetails implements Action {
  readonly type = GroupDetailActionTypes.LoadGroupDetails;
  constructor(public payload: Group) {}
}
export class UpdateGroupDetails implements Action {
  readonly type = GroupDetailActionTypes.UpdateGroupDetails;
  constructor(public payload: Group) {}
}


export type GroupDetailActions = LoadGroupDetails
  | GetGroupDetails
  | UpdateGroupDetails;
